import React from 'react';
import Dashboard from '../../components/DashboardUniv';
import './ClassProgress.module.scss';
import firebase from 'firebase';
import UserContext from '../../User/User';
import { Line } from 'react-chartjs-2';
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip';

class Class_Progress extends React.Component {
	constructor() {
		super();

		this.state = {
			section: [{}, {}, {}],

			labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
			datasets: [
				{
					label: 'Cumulative Average',
					fill: true,
					lineTension: 0.5,
					backgroundColor: 'rgba(236, 39, 39,0.25)',
					borderColor: '#EC2727',
					borderWidth: 3,
					data: [65, 59, 80, 81, 90],
				},
			],
			cumulativeClass: 'progress-back',
			javaClass: 'progress-back',
			vueClass: 'progress-back',
			angularClass: 'progress-back',
			reactClass: 'progress-back',
			presentationClass: 'progress-back',
			remoteClass: 'progress-back',
		};

		this.changeData = this.changeData.bind(this);
		// this.selectedArea = this.selectedArea.bind(this)
	}

	static contextType = UserContext;

	changeData(area) {
		if (area == 'java') {
			this.setState({
				datasets: [
					{
						label: 'Java Average',
						fill: true,
						lineTension: 0.5,
						backgroundColor: 'rgba(50,64,195,0.25)',
						borderColor: '#3240C3',
						borderWidth: 3,
						data: [80, 75, 72, 84, 80],
					},
				],
				cumulativeClass: 'progress-back',
				javaClass: 'progress-back progress-select',
				vueClass: 'progress-back',
				angularClass: 'progress-back',
				reactClass: 'progress-back',
				presentationClass: 'progress-back',
				remoteClass: 'progress-back',
			});
		} else if (area == 'vue') {
			this.setState({
				datasets: [
					{
						label: 'Vue Average',
						fill: true,
						lineTension: 0.5,
						backgroundColor: 'rgba(253, 152, 1,0.25)',
						borderColor: '#FD9801',
						borderWidth: 3,
						data: [40, 50, 62, 75, 73],
					},
				],
				cumulativeClass: 'progress-back',
				javaClass: 'progress-back',
				vueClass: 'progress-back progress-select',
				angularClass: 'progress-back',
				reactClass: 'progress-back',
				presentationClass: 'progress-back',
				remoteClass: 'progress-back',
			});
		} else if (area == 'angular') {
			this.setState({
				datasets: [
					{
						label: 'Angular Average',
						fill: true,
						lineTension: 0.5,
						backgroundColor: 'rgba(89, 15, 148,0.25)',
						borderColor: '#590F94',
						borderWidth: 3,
						data: [66, 75, 80, 79, 85],
					},
				],
				cumulativeClass: 'progress-back',
				javaClass: 'progress-back',
				vueClass: 'progress-back',
				angularClass: 'progress-back progress-select',
				reactClass: 'progress-back',
				presentationClass: 'progress-back',
				remoteClass: 'progress-back',
			});
		} else if (area == 'react') {
			this.setState({
				datasets: [
					{
						label: 'React Average',
						fill: true,
						lineTension: 0.5,
						backgroundColor: 'rgba(202, 44, 44,0.25)',
						borderColor: '#CA2C2C',
						borderWidth: 3,
						data: [75, 85, 90, 85, 93],
					},
				],
				cumulativeClass: 'progress-back',
				javaClass: 'progress-back',
				vueClass: 'progress-back',
				angularClass: 'progress-back',
				reactClass: 'progress-back progress-select',
				presentationClass: 'progress-back',
				remoteClass: 'progress-back',
			});
		} else if (area == 'presentation') {
			this.setState({
				datasets: [
					{
						label: 'Presentation Average',
						fill: true,
						lineTension: 0.5,
						backgroundColor: 'rgba(50, 169, 195,0.25)',
						borderColor: '#32A9C3',
						borderWidth: 3,
						data: [90, 85, 88, 92, 95],
					},
				],
				cumulativeClass: 'progress-back',
				javaClass: 'progress-back',
				vueClass: 'progress-back',
				angularClass: 'progress-back',
				reactClass: 'progress-back',
				presentationClass: 'progress-back progress-select',
				remoteClass: 'progress-back',
			});
		} else if (area == 'remote') {
			this.setState({
				datasets: [
					{
						label: 'Remote Average',
						fill: true,
						lineTension: 0.5,
						backgroundColor: 'rgba(87, 192, 61,0.25)',
						borderColor: '#57C03D',
						borderWidth: 3,
						data: [85, 85, 86, 90, 93],
					},
				],
				cumulativeClass: 'progress-back',
				javaClass: 'progress-back',
				vueClass: 'progress-back',
				angularClass: 'progress-back',
				reactClass: 'progress-back',
				presentationClass: 'progress-back',
				remoteClass: 'progress-back progress-select',
			});
		} else if (area == 'cumulative') {
			this.setState({
				datasets: [
					{
						label: 'Cumulative Average',
						fill: true,
						lineTension: 0.5,
						backgroundColor: 'rgba(236, 39, 39,0.25)',
						borderColor: '#EC2727',
						borderWidth: 3,
						data: [65, 59, 80, 81, 90],
					},
				],
				cumulativeClass: 'progress-back progress-select',
				javaClass: 'progress-back',
				vueClass: 'progress-back',
				angularClass: 'progress-back',
				reactClass: 'progress-back',
				presentationClass: 'progress-back',
				remoteClass: 'progress-back',
			});
		}

		//this.selectedArea(area);
	}

	/*
    selectedArea(area){
        ReactDOM.findDOMNode(document.getElementById('java')).style.backgroundColor = '#3240C3';
        ReactDOM.findDOMNode(document.getElementById('vue')).style.backgroundColor = '#FD9801';
        ReactDOM.findDOMNode(document.getElementById('angular')).style.backgroundColor = '#590F94';
        ReactDOM.findDOMNode(document.getElementById('react')).style.backgroundColor = '#CA2C2C';
        ReactDOM.findDOMNode(document.getElementById('presentation')).style.backgroundColor = '#32A9C3';
        ReactDOM.findDOMNode(document.getElementById('remote')).style.backgroundColor = '#57C03D';
        ReactDOM.findDOMNode(document.getElementById('cumulative')).style.backgroundColor = '#EC2727';
        var x = document.getElementById(area);
        ReactDOM.findDOMNode(x).style.backgroundColor = '#4BACE9';
    }
    */
	render() {
		//User data

		return (
			<React.Fragment>
				<section class="hero-university2"></section>
				<section class="candidate_process">
					<section class="col-container">
						<Dashboard />

						{/*right expands when dashboard is closed*/}
						<div class="rightClassProgress">
							<div class="sectionMenu">
								<button>Section 1</button>
								<button>Section 2</button>
								<button>Section 3</button>
							</div>
							<div class="sectionBlock">
								<h1>Section 1</h1>
								<div class="cumulativeAvg">
									<div
										class="progressColumnCumulative"
										data-tip
										data-for="avgText"
									>
										<div
											class={this.state.cumulativeClass}
											onClick={() => this.changeData('cumulative')}
										>
											<p>Cumulative Average</p>
											<div
												class="progress-bar"
												style={{
													backgroundColor: '#EC2727',
													width: '90%',
												}}
											></div>
										</div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="avgText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Cumulative Average Tooltip
									</ReactTooltip>
									<div
										class="progressColumnPercents"
										style={{ height: '50px' }}
									>
										<h4>90%</h4>
									</div>
								</div>
								<h3>Select area to view progress</h3>
								<div class="progressColumnBars">
									<div
										class={this.state.javaClass}
										onClick={() => this.changeData('java')}
										data-tip
										data-for="javaText"
									>
										<p>Java</p>
										<div
											class="progress-bar"
											style={{
												backgroundColor: '#3240C3',
												width: '80%',
											}}
										></div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="javaText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Java is a class-based, object-oriented programming
										language that is designed to have as few
										implementation dependencies as possible.
									</ReactTooltip>
									<div
										class={this.state.vueClass}
										onClick={() => this.changeData('vue')}
										data-tip
										data-for="vueText"
									>
										<p>Vue</p>
										<div
											class="progress-bar"
											style={{
												backgroundColor: '#FD9801',
												width: '73%',
											}}
										></div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="vueText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Vue.js is an open-source model–view–viewmodel
										JavaScript framework for building user interfaces
										and single-page applications.
									</ReactTooltip>
									<div
										class={this.state.angularClass}
										onClick={() => this.changeData('angular')}
										data-tip
										data-for="angularText"
									>
										<p>Angular</p>
										<div
											class="progress-bar"
											style={{
												backgroundColor: '#590F94',
												width: '85%',
											}}
										></div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="angularText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Angular is a TypeScript-based open-source web
										application framework led by the Angular Team at
										Google and by a community of individuals and
										corporations.
									</ReactTooltip>
								</div>
								<div class="progressColumnPercents">
									<h4>80%</h4>
									<h4>73%</h4>
									<h4>85%</h4>
								</div>
								<div class="progressColumnBars">
									<div
										class={this.state.reactClass}
										onClick={() => this.changeData('react')}
										data-tip
										data-for="reactText"
									>
										<p>React</p>
										<div
											class="progress-bar"
											style={{
												backgroundColor: '#CA2C2C',
												width: '93%',
											}}
										></div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="reactText"
										place="top"
										effect="solid"
										multiline={true}
									>
										React is an open-source JavaScript library for
										building user interfaces or UI components.
									</ReactTooltip>
									<div
										class={this.state.presentationClass}
										onClick={() => this.changeData('presentation')}
										data-tip
										data-for="presentationText"
									>
										<p>Presentation</p>
										<div
											class="progress-bar"
											style={{
												backgroundColor: '#32A9C3',
												width: '95%',
											}}
										></div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="presentationText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Tooltip for presentation
									</ReactTooltip>
									<div
										class={this.state.remoteClass}
										onClick={() => this.changeData('remote')}
										data-tip
										data-for="remoteText"
									>
										<p>Remote Productivity</p>
										<div
											class="progress-bar"
											style={{
												backgroundColor: '#57C03D',
												width: '93%',
											}}
										></div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="remoteText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Tooltip for remote
									</ReactTooltip>
								</div>
								<div class="progressColumnPercents">
									<h4>93%</h4>
									<h4>95%</h4>
									<h4>93%</h4>
								</div>
								<Line
									data={this.state}
									options={{
										title: {
											display: true,
											text: 'Class Average per week',
											fontSize: 20,
										},
										legend: {
											display: true,
											position: 'right',
										},
										scales: {
											xAxes: [
												{
													display: true,
													scaleLabel: {
														display: true,
														labelString: 'Week',
													},
												},
											],
											yAxes: [
												{
													display: true,
													ticks: {
														beginAtZero: true,
														steps: 10,
														stepValue: 5,
														max: 100,
													},
												},
											],
										},
									}}
								/>
							</div>

							<div class="centerButton">
								<button class="hvr-sweep">View Student Progress</button>
							</div>
						</div>
					</section>
				</section>
			</React.Fragment>
		);
	}
}

export default Class_Progress;
